module.exports = {
      id: "payment-3-usage",
      viewBox: "0 0 42 43",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#payment-3-usage",
      toString: function () {
        return this.url;
      }
    }